import type { Translations } from "../types";

const de: Translations = {
  nav: {
    features: "Funktionen",
    pricing: "Preise",
    blog: "Blog",
    freeTools: "Kostenlose Tools",
    contact: "Kontakt",
    startFree: "Kostenlos starten",
    solutions: "Lösungen",
    useCases: "Anwendungsfälle",
    switchToDark: "Zum Dunklen Modus wechseln",
    switchToLight: "Zum Hellen Modus wechseln",
    solutionsToolsDesc: "Rechner, Generatoren und mehr",
    solutionsUseCasesDesc: "Zapify in Aktion erleben",
  },
  hero: {
    rotatingWords: ["Auto DMs", "KI Antworten"],
    headline: "Antworte auf Instagram-Kommentare mit",
    subheadline:
      "Antworte automatisch auf Kommentare mit personalisierten DMs. Erfasse Leads und lass deine Zielgruppe auf Autopilot wachsen.",
    cta: "Kostenlos starten",
    helperText: "Kostenlos zum Start",
    helperSeparator: "Einfache Einrichtung",
    trustedBy: "Verwendet von",
    creators: "5.000+ Creator",
    dmsSent: "DMs gesendet",
    dmsCount: "1.000.000+",
  },
  features: {
    headingTitle: "Alles was du brauchst um",
    headingHighlight: "Dein Instagram zu skalieren",
    headingDescription:
      "Zapify gibt dir die volle Kontrolle über deinen KI-Assistenten und die Automatisierung und spart Stunden manueller Arbeit.",
    cta: "30 Tage kostenlos testen",
    items: [
      {
        title: "DM-Automatisierung",
        description:
          "Antworte automatisch auf jeden Instagram-Kommentar per DM. Verwandle DM-Chaos in qualifizierte Leads und Verkäufe.",
      },
      {
        title: "Follow-Anfrage",
        description:
          "Bevor wir deinen exklusiven Inhalt teilen, bitten wir den Benutzer, dir zu folgen.",
      },
      {
        title: "KI-gestützte Antworten",
        description:
          "Antworten, die den Kommentar verstehen und wie du klingen.",
      },
      {
        title: "Vollständig anpassbare Stimme",
        description:
          "Wähle Ton und Stil, kurze/lange Antworten und kontrolliere Emojis + #Hashtags.",
      },
      {
        title: "Globale Sprachunterstützung",
        description: "Sprich ihre Sprache, automatisch.",
      },
      {
        title: "E-Mails sammeln",
        description:
          "Baue deine E-Mail-Liste automatisch aus Instagram-Kommentaren auf.",
      },
      {
        title: "Team-Zugang",
        description:
          "Lade Teammitglieder ein, um Antworten, Leads und Gespräche gemeinsam zu verwalten.",
      },
      {
        title: "Mehrere Instagram-Konten",
        description:
          "Verbinde und verwalte mehrere Instagram-Konten von einem Dashboard aus.",
      },
    ],
  },
  process: {
    headingTitle: "Starte die Automatisierung in",
    headingHighlight: "Minuten",
    headingDescription:
      "Folge diesen einfachen Schritten, um deine DMs zu automatisieren",
    step: "Schritt",
    cta: "Automatisierung starten",
    steps: [
      {
        title: "Auslöser auswählen",
        description:
          "Wähle welche Beiträge und Schlüsselwörter deine Automatisierung aktivieren.",
      },
      {
        title: "Antwort automatisieren",
        description:
          "Erstelle personalisierte Nachrichten mit Links, Angeboten oder Inhalten zum automatischen Versand.",
      },
      {
        title: "Viral",
        description:
          "Erstelle mehr. Verwalte weniger. Die Automatisierung erledigt den Rest.",
      },
    ],
  },
  engagement: {
    headingTitle: "Verwandle Instagram-Engagement in",
    headingHighlight: "Umsatz auf Autopilot",
    headingDescription:
      "Verwandle jeden Kommentar in Verkaufschancen. Verdiene Geld 24/7, während dein KI-Assistent die Gespräche führt",
    card1Title: "Link-Klicks steigern",
    card1TitleLine2: "Konversionen",
    card1Description:
      "Verwandle Kommentare in direkten Traffic. Liefere deine Angebote, Produkte und Inhalte automatisch direkt an interessierte Käufer über DMs.",
    card2Title: "24/7 KI-Verkaufsagent",
    card2Description:
      "Verpasse nie einen Kommentar. Antworte sofort und verwandle Gespräche in Verkäufe 24/7, während du schläfst.",
  },
  graph: {
    headingHighlight: "Katapultiere deine",
    headingHighlightWord: "Reichweite",
    headingDescription:
      "Sieh, wie automatisierte DMs und KI-Antworten deine Engagement-Rate, dein Follower-Wachstum und deine Verkaufskonversionen um bis zu 10x steigern",
    title: "Engagement steigern",
    by10x: "um 10x",
    subtitle: "Monetarisiere dein Publikum, während du schläfst",
    description:
      "Antworte auf jeden Kommentar, verwandle sie in DMs und steigere das Engagement automatisch.",
    afterZapify: "Nach Zapify Pro",
    cta: "Engagement jetzt steigern",
  },
  testimonials: {
    headingTitle: "Warum Instagram-Creator",
    headingHighlight: "Lieben",
    headingDescription:
      "Echte Erfolgsgeschichten von Influencern und Marken, die ihr Instagram-Engagement und ihre Einnahmen mit KI-Automatisierung transformiert haben",
    followers: "Follower",
  },
  faq: {
    headingTitle: "Häufig gestellte",
    headingHighlight: "Fragen",
    headingDescription:
      "Alles, was du wissen musst, um mit Zapify loszulegen",
    items: [
      {
        question: "Funktioniert Zapify mit jedem Instagram-Konto?",
        answer:
          "Zapify unterstützt professionelle Instagram-Konten (Business oder Creator). Persönliche Konten werden von der API nicht unterstützt.",
      },
      {
        question: "Ist Zapify auf dem Handy verfügbar?",
        answer:
          "Ja, Zapify funktioniert hervorragend in deinem mobilen Browser, du kannst die Browser-App von hier installieren.",
      },
      {
        question: "Klingen die Automatisierungen roboterhaft?",
        answer:
          "Nein. Zapify unterstützt Markenstimmen-Kontrollen (Ton, Länge, Emoji-Nutzung), damit die KI-Antworten deinem Stil entsprechen. Du kannst jede Nachricht bearbeiten und eine menschliche Übergabe hinzufügen.",
      },
      {
        question: "Ist Zapify von Meta genehmigt?",
        answer:
          "Zapify ist ein verifizierter Technologieanbieter von Meta, wir verwenden die offiziellen Instagram Graph APIs. Wir halten uns an Rate-Limits und Richtlinien, um dein Konto sicher zu halten.",
      },
      {
        question: "Ist Zapify sicher zu verwenden?",
        answer:
          "Ja. Die gesamte Authentifizierung verwendet Metas sicheres OAuth. Wir fragen nie nach deinem Instagram-Passwort und respektieren die API-Berechtigungen, die du erteilst.",
      },
      {
        question: "Ist Zapify kostenlos?",
        answer:
          "Wir bieten eine kostenlose Testversion an, damit du Automatisierungen testen und Ergebnisse sehen kannst, bevor du upgradest.",
      },
      {
        question: "Gibt es ein Partner-/Affiliate-Programm?",
        answer:
          "Ja. Zugelassene Partner verdienen Provisionen bei Neuanmeldungen und Verlängerungen. Bewerbe dich auf unserer Partner-Seite.",
      },
      {
        question: "Wie kontaktiere ich den Support?",
        answer:
          "Nutze den In-App-Chat oder sende uns eine E-Mail — die meisten Fragen werden an Werktagen noch am selben Tag beantwortet. Wir bieten auch Einrichtungsanleitungen und Best-Practice-Vorlagen.",
      },
    ],
  },
  verified: {
    headingTitle: "Programme",
    headingHighlight: "& Partner",
    headingDescription:
      "Unser Startup wurde von Stripe for Startups und Microsoft for Startups 2025 akzeptiert",
    cta: "Verifizierung ansehen",
    badge: "Verifiziert",
    heading: "Dein vertrauenswürdiger, von Meta verifizierter Technologieanbieter",
    description: "Unser Unternehmen ist offiziell in Microsoft Startups for Founders und Stripe Startup Program aufgenommen.",
    missionNote: "Siehe: Startseite → Abschnitte Held und Creator-Probleme für unsere Mission und unsere Werte.",
    close: "Schließen",
  },
  // Stats
  stats: {
    dmsSent: "Gesendete DMs",
    followersGained: "Gewonnene Follower",
    commentsSent: "Gesendete Kommentare",
    countries: "Länder",
  },

  // Pricing
  pricing: {
    headingTitle: "Wähle den Plan, der",
    headingHighlight: "zu dir passt",
    headingDescription:
      "Flexible Preise für jeden Creator — jederzeit wechseln und mehr bei jährlicher Abrechnung sparen",
    monthly: "Monatlich",
    yearly: "Jährlich",
    get2MonthsFree: "2 Monate Gratis",
    freeTrial: "Kostenlose Testversion",
    freeTrialDesc: "Perfekt, um mit Zapify zu starten.",
    starter: "Starter",
    starterDesc: "Ideal für einzelne Content Creator.",
    professional: "Professionell",
    professionalDesc: "Ideal für Startups und kleine Marken.",
    subscribe: "Abonnieren",
    startFreeTrial: "30 Tage kostenlos testen",
    free: "KOSTENLOS",
    noCreditCard: "Keine Kreditkarte",
    bestSeller: "Bestseller",
    perMonth: "/Monat",
    save: "Spare",
    unlimited: "Unbegrenzt",
    limited: "Begrenzt",
    email: "E-Mail",
    priority: "Priorität",
    automations: "Automatisierungen",
    dms: "DMs",
    aiReplies: "KI-Antworten",
    askToFollow: "Follow-Anfrage",
    emailCollection: "E-Mail-Erfassung",
    igProfile: "IG-Profil",
    teamAccess: "Team-Zugang",
    support: "Support",
    // Category headers
    automationPower: "Automationskraft",
    aiCapabilities: "KI-Fähigkeiten",
    leadGeneration: "Lead-Generierung",
    analyticsTeam: "Analysen & Team",
    supportPlatform: "Support & Plattform",
    soonBadge: "Bald",
    // AUTOMATION POWER features
    activeAutomations: "Aktive Automatisierungen",
    instagramAccounts: "Instagram-Konten",
    customTriggerWords: "Benutzerdefinierte Trigger-Wörter",
    instantDMReplies: "Sofortige DM-Antworten",
    commentToDMAutomation: "Kommentar-zu-DM-Automatisierung",
    storyReplyAutomation: "Story-Antwort-Automatisierung",
    welcomeMessageAutomation: "Willkommensnachricht-Automatisierung",
    smartGreetingMessage: "Intelligente Begrüßungsnachricht",
    unlimitedPostsStories: "Unbegrenzte Posts & Stories automatisiert",
    flexiblePostTargeting: "Flexible Post-Ausrichtung (nächster, beliebiger, mehrere)",
    linkInDMCTAButtons: "Links in DM & CTA-Buttons",
    followGatedDMsLinks: "Follow-gated DMs & Links",
    instagramSafetyLimits: "Instagram-Sicherheitslimits",
    customFlowBuilder: "Individueller Flow-Builder",
    // AI CAPABILITIES features
    aiCommentReplies: "KI-Kommentarantworten / Monat",
    aiPoweredInstantReplies: "KI-gestützte Sofortantworten",
    aiTrainedOnBrand: "KI auf Ihre Marke trainiert",
    // LEAD GENERATION features
    storedContacts: "Gespeicherte Kontakte",
    emailCaptureInsideDMs: "E-Mail-Erfassung in DMs",
    // ANALYTICS & TEAM features
    instagramInsights: "Instagram-Insights",
    monthlyPerformanceReports: "Monatliche Leistungsberichte",
    teamMembers: "Team-Mitglieder",
    // SUPPORT & PLATFORM features
    customerSupport: "Kundensupport",
    languageSupport: "Sprachunterstützung",
    platformBranding: "Plattform-Branding",
    offerTitle: "Zeitlich begrenztes Angebot",
    offerDesc: "Registriere dich heute und erhalte",
    offerBadge: "10% RABATT HEUTE",
    limitedSpots: "Begrenzte Plätze",
    offerEndsIn: "Angebot endet in",
    days: "Tage",
    hours: "Stunden",
    minutes: "Minuten",
    seconds: "Sekunden",
    claimed: "beansprucht",
    secureCheckout: "Sicherer Checkout",
    noCreditCardRequired: "Keine Kreditkarte erforderlich",
    copied: "KOPIERT!",
    comparePlansEyebrow: "Ohne Marketing-Fuzz",
    comparePlansTitle: "Schneller entscheiden als dein nächster Post live geht",
    comparePlansSubtitle:
      "Automationen, DMs, KI, Team-Zugänge - alles in einer Zeile, damit klar ist, was \"unlimited\" wirklich heißt. Einmal lesen, einmal wählen, fertig.",
    compareFeatureColumn: "Funktion",
    plansCtaBadgeLead: "Clever starten.",
    plansCtaBadgeEmphasis: "Mehr schaffen.",
    plansCtaTitleLead: "Nicht gebaut, dich zu halten.",
    plansCtaTitleGradient: "Gebaut, dich zu befreien.",
    plansCtaSubtitle:
      "Viele Wachstumstools machen dich abhängig. Wir machen das Gegenteil: Lärm automatisieren, dort bleiben, wo es zählt, echte Chats in Schwung verwandeln.",
    plansCtaSubtitleParagraph2:
      "Wenn alles so leise läuft, dass du uns kaum noch merkst—dann war's richtig.",
    plansCtaBullet1: "Keine Kreditkarte nötig",
    plansCtaBullet3: "Jederzeit kündbar, ohne Langzeitbindung",
    plansCtaTrust: "Über 5.000 Creators weltweit vertrauen uns",
    signupMixEyebrow: "Anmelde-Snapshot",
    signupMixCountLabel: "Anmeldungen in dieser Stichprobe",
    signupMixLeadTitle: "So haben sie gestartet",
    signupMixLeadSubtitle:
      "Die meisten beginnen mit einer kostenlosen Testphase. Der Rest teilt sich auf Starter und den direkten Einstieg bei Professional.",
    signupMixLabelFreeTrial: "Kostenlose Testphase",
    signupMixLabelStarter: "Starter",
    signupMixLabelProfessional: "Professional",
  },

  // CTA
  cta: {
    readyToTransform: "Bereit, dein Instagram zu transformieren?",
    joinThousands:
      "Schließe dich Tausenden von Creatorn und Marken an, die Zapify nutzen, um Follower zu gewinnen, Engagement zu steigern und Zeit zu sparen.",
    startForFree: "Kostenlos starten",
  },

  // Sticky
  sticky: {
    instantlyDm:
      "Sende sofort DMs an jeden, der auf deinem Instagram kommentiert",
    limitedOffer: "Zeitlich begrenztes Angebot - 10% RABATT",
    endsIn: "Endet in",
    getStartedFree: "Kostenlos starten",
    start: "Starten",
  },

  // Contact Page
  contactPage: {
    heading: "Support kontaktieren",
    subtitle:
      "Wir helfen dir gerne weiter. Kontaktiere uns bei Fragen oder für Unterstützung.",
    connectWithUs: "Kontaktiere uns",
    connectDescription: "Wähle deinen bevorzugten Kontaktweg",
    emailUs: "Schreib uns eine E-Mail",
    emailResponse: "Wir antworten innerhalb von 24 Stunden",
    support: "Support",
    getInstantHelp: "Sofortige Hilfe auf",
    scheduleMeet: "Termin vereinbaren",
    followUs: "Folge uns",
    stayUpdated: "Bleib auf dem Laufenden",
    responseTime: "Antwort innerhalb von 24h",
  },

  // Contact Form
  contactForm: {
    heading: "Schreib uns eine Nachricht",
    description: "Fülle das Formular aus und wir melden uns bei dir",
    fullName: "Vollständiger Name",
    fullNamePlaceholder: "Gib deinen vollständigen Namen ein",
    emailAddress: "E-Mail-Adresse",
    emailPlaceholder: "Gib deine E-Mail-Adresse ein",
    subject: "Betreff",
    subjectPlaceholder: "Worum geht es?",
    message: "Nachricht",
    messagePlaceholder: "Erzähl uns mehr über dein Anliegen...",
    sending: "Wird gesendet...",
    sendMessage: "Nachricht senden",
    successMessage: "Nachricht erfolgreich gesendet! Wir melden uns bald bei dir.",
    errorMessage: "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
  },

  // Blog
  blog: {
    insightsStrategy: "Einblicke und Strategie",
    masterTheArt: "Meistere die Kunst des",
    instagramGrowth: "Instagram-Wachstums",
    blogSubtitle: "Entdecke Experten-Anleitungen, Automatisierungsgeheimnisse und bewährte Strategien, um deine Kommentare in Kunden zu verwandeln.",
    searchPlaceholder: "Strategien, Anleitungen suchen...",
    followForUpdates: "Folge uns für Updates",
    latestStories: "Neueste Artikel",
    minRead: "Min. Lesezeit",
    readStory: "Artikel lesen",
    featuredStory: "Empfohlener Artikel",
    freshDrop: "Neu erschienen",
    readArticle: "Artikel lesen",
    noArticlesFound: "Keine Artikel gefunden",
    noArticlesDescription: "Wir konnten keine Artikel finden, die deiner Suche entsprechen. Versuche, deine Filter anzupassen, oder schau später wieder vorbei.",
    clearSearch: "Suche löschen",
  },

  // Referral
  referral: {
    heading: "Tritt unserem Empfehlungs-",
    headingHighlight: "Programm bei",
    description: "Empfiehl Zapify deinen Freunden und verdiene 20 % des Gesamtumsatzes, den sie im ersten Jahr für ein kostenpflichtiges Abo ausgeben.",
    proSubscriber: "Zapify Pro Abonnent",
    minimumDms: "mindestens 100 DMs gesendet",
    joinProgram: "Dem Empfehlungsprogramm beitreten",
    termsOfService: "Nutzungsbedingungen.",
    step1: "Schritt 1",
    step1Title: "Hol dir deinen Empfehlungslink",
    step1Desc: "Melde dich in Minuten an — keine Genehmigung nötig! Wenn du Pro-Abonnent bist und über 100 DMs gesendet hast, kannst du sofort anfangen zu verdienen.",
    referralLink: "Empfehlungslink",
    copy: "Kopieren",
    step2: "Schritt 2",
    step2Title: "Teilen und bewerben",
    step2Desc: "Kopiere deinen Link und teile ihn überall — Instagram, TikTok, YouTube, E-Mail oder DMs. Je mehr du teilst, desto mehr verdienst du!",
    step3: "Schritt 3",
    step3Title: "Verdiene 20 % Provision",
    step3Desc: "Wenn jemand über deinen Link ein kostenpflichtiges Abo abschließt, verdienst du 20 % seiner Zahlungen im ersten Jahr — monatlich ausgezahlt!",
    quickStats: "Schnelle Statistiken",
    clicks: "Klicks",
    converted: "Konvertiert",
    total: "Gesamt",
    pending: "Ausstehend",
    faqHeading: "Empfehlungsprogramm",
    faqSubheading: "Die häufigsten Fragen zu unserem Empfehlungsprogramm",
    faq1Q: "Was ist das Zapify Empfehlungsprogramm?",
    faq1A: "Das Zapify Empfehlungsprogramm ermöglicht es dir, Provisionen zu verdienen, indem du neue Nutzer auf unsere Plattform verweist. Wenn sich jemand über deinen einzigartigen Empfehlungslink für ein kostenpflichtiges Abo anmeldet, verdienst du 20 % seiner Abogebühren im ersten Jahr.",
    faq2Q: "Wer kann dem Empfehlungsprogramm beitreten?",
    faq2A: "Um beizutreten, musst du Zapify Pro Abonnent sein und mindestens 100 DMs mit unseren Automatisierungstools gesendet haben. So stellen wir sicher, dass unsere Partner aktive Nutzer sind, die die Plattform ehrlich empfehlen können.",
    faq3Q: "Wie und wann werde ich bezahlt?",
    faq3A: "Provisionen werden monatlich über PayPal ausgezahlt, sobald deine Einnahmen die Mindestauszahlungsgrenze von 50 $ erreichen. Zahlungen werden etwa 30 Tage nach Ende des Monats verarbeitet, in dem sie verdient wurden.",
    faq4Q: "Gibt es ein Limit, wie viel ich verdienen kann?",
    faq4A: "Nein! Es gibt keine Obergrenze für deine Einnahmen. Je mehr erfolgreiche Empfehlungen du machst, desto mehr verdienst du.",
  },

  // Tools Page
  toolsPage: {
    heading: "Kostenlose Instagram",
    headingHighlight: "Tools",
    description:
      "Rechner, Generatoren, Formatierungstools und mehr — alles kostenlos, ohne Anmeldung. Für Creator, die intelligenter wachsen wollen.",
    searchPlaceholder: "Tools suchen...",
    all: "Alle",
    noToolsFound: "Keine Tools gefunden, die deiner Suche entsprechen.",
    free: "Kostenlos",
    comingSoon: "Demnächst",
    relatedTools: "Ähnliche Tools",
    relatedToolsDesc: "Mehr kostenlose Tools für dein Instagram-Wachstum",
    viewAllTools: "Alle kostenlosen Tools anzeigen",
    frequentlyAsked: "Häufig gestellte",
    questionsHighlight: "Fragen",
    faqDescription: "Alles, was du über das Tool wissen musst:",
  },

  // Use Case
  useCase: {
    heading: "Was kannst du mit",
    headingHighlight: "Zapify automatisieren?",
    description: "Vom Verkaufsantrieb bis zur E-Mail-Erfassung — erfahre, wie Creator und Marken Zapify nutzen, um ihre Instagram-DMs zu automatisieren und auf Autopilot zu wachsen.",
    startForFree: "Kostenlos starten",
    learnMore: "Mehr erfahren",
    bottomCtaHeading: "Bereit, deine Instagram-DMs zu automatisieren?",
    bottomCtaDesc: "Schließe dich Tausenden von Creatorn an, die Zapify nutzen, um Gespräche automatisch in Verkäufe zu verwandeln.",
    freeToStart: "Kostenlos zum Start · Einfache Einrichtung",
  },

  footer: {
    description:
      "Das #1 Instagram DM-Automatisierungstool, dem über 5.000 Creator weltweit vertrauen.",
    product: "Produkt",
    company: "Unternehmen",
    compare: "Vergleichen",
    howItWorks: "Wie es funktioniert",
    termsOfService: "Nutzungsbedingungen",
    privacyPolicy: "Datenschutzrichtlinie",
    refundPolicy: "Rückerstattungsrichtlinie",
    contactUs: "Kontaktiere uns",
    referralProgram: "Empfehlungsprogramm",
    copyright: "Alle Rechte vorbehalten.",
    builtWith: "Mit \u2764\uFE0F für Creator gemacht",
    useCasesHeading: "Anwendungsfälle",
    allUseCases: "Alle Anwendungsfälle",
    sendLinksInDms: "Links per DM senden",
    autoRespondComments: "Automatische Kommentar-Antworten",
    collectEmails: "E-Mails sammeln",
    storyReplies: "Story-Antworten",
  },

  // Auth
  auth: {
    welcomeToZapify: "Willkommen bei Zapify",
    setItUpOnce: "Einmal einrichten. Die KI erledigt den Rest.",
    recommended: "Empfohlen",
    continueWithInstagram: "Weiter mit Instagram",
    continueWithGoogle: "Weiter mit Google",
    redirecting: "Weiterleitung...",
    orContinueWithEmail: "oder weiter mit E-Mail",
    emailAddress: "E-Mail-Adresse",
    emailRequired: "E-Mail ist erforderlich",
    validEmail: "Bitte gib eine gültige E-Mail-Adresse ein",
    sendingCode: "Code wird gesendet...",
    startFree: "Kostenlos starten",
    enterVerificationCode: "Bestätigungscode eingeben",
    weSentCode: "Wir haben einen 6-stelligen Code gesendet an",
    otpRequired: "OTP ist erforderlich",
    otpDigits: "OTP muss 6 Ziffern haben",
    verifying: "Wird überprüft...",
    verifyAndContinue: "Bestätigen und fortfahren",
    useDifferentEmail: "Andere E-Mail verwenden",
    agreeToTerms: "Durch Fortfahren stimmst du unseren",
    termsOfService: "Nutzungsbedingungen",
    and: "und",
    privacyPolicy: "Datenschutzrichtlinie",
    haveDiscountCode: "Hast du einen Rabattcode?",
    discountCode: "Rabattcode",
    enterCode: "Code eingeben",
    apply: "Anwenden",
    applied: "Angewendet",
    congratsDiscount: "Glückwunsch! Du hast 20 % Extra-Rabatt erhalten.",
    invalidCode: "Ungültiger Rabattcode",
    redirectingToDashboard: "Weiterleitung zum Dashboard...",
    referralBannerText: "Glückwunsch! Du hast 20 % Extra-Rabatt erhalten.",
    extendedTrialBannerText: "Glückwunsch! Du hast {days} Tage kostenlose Testversion freigeschaltet.",
  },

  // Comparison
  comparison: {
    updatedDate: "Aktualisiert März 2026",
    startFreeNoCreditCard: "Kostenlos starten — Keine Kreditkarte",
    seeFullComparison: "Vollständigen Vergleich ansehen",
    quickAnswer: "Schnelle Antwort",
    featureComparison: "Funktionsvergleich im Detail",
    samePriceTitle: "Gleicher Preis, aber was bekommst du wirklich?",
    aiVsKeywords: "KI-Absichtserkennung vs einfache Schlüsselwort-Vorlagen",
    userComments: "Was Nutzer wirklich in Kommentare schreiben:",
    bottomCtaHeading: "Bereit, die intelligentere Alternative auszuprobieren?",
    bottomCtaDesc: "Schließe dich Tausenden von Creatorn an, die zu Zapify für KI-gestützte Instagram-Automatisierung gewechselt haben.",
    getStarted: "Kostenlos starten",
    freeToStart: "Kostenlos zum Start · Keine Kreditkarte erforderlich",
    feature: "Funktion",
    category: "Kategorie",
    pricingTiers: "Preisstufen",
    faq: "Häufig gestellte Fragen",
  },

  // Legal
  legal: {
    lastUpdated: "Zuletzt aktualisiert",
    haveQuestions: "Hast du Fragen?",
    contactEmail: "Schreib uns gerne an",
    returnToWebsite: "Zurück zur Webseite",
    termsOfService: "Nutzungsbedingungen",
    privacyPolicy: "Datenschutzrichtlinie",
    refundPolicy: "Rückerstattungsrichtlinie",
    dataDeletion: "Richtlinie zur Datenlöschung",
  },

  // Use Case Layout
  useCaseLayout: {
    startForFree: "Kostenlos starten",
    freeToStart: "Kostenlos zum Start · Einfache Einrichtung",
    frequentlyAsked: "Häufig gestellte",
    questionsHighlight: "Fragen",
    readyToAutomate: "Bereit, deine Instagram-DMs zu automatisieren?",
    readyToAutomateDesc: "Schließe dich Tausenden von Creatorn an, die Zapify nutzen, um Gespräche automatisch in Verkäufe zu verwandeln.",
    trigger: "Auslöser:",
    response: "Antwort:",
    exploreMore: "Mehr entdecken",
  },
};

export default de;
